import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar.jsx";
import Header from "../components/Header.jsx";

const AdminLayout = () => {
  return (
    <div className="flex h-screen w-full overflow-hidden">
      
      {/* Sidebar */}
      <Sidebar />

      {/* Right section */}
      <div className="flex flex-col flex-1 w-full overflow-hidden">
        
        {/* Header */}
        <Header />

        {/* Main Content */}
        <main className="p-4 flex-1 w-full overflow-y-auto">
          <Outlet />
        </main>

      </div>
    </div>
  );
};

export default AdminLayout;
